import Vue from 'vue'

interface UserState {
    userInfo: {
        id: number,
        user: { id: number, email: string, first_name: string, last_name: string },
        comune: { id: number, nome: string, logo: string },
        e_un_operatore_gestionale_mapplants: boolean
        e_un_operatore_manutenzione: boolean
        e_un_operatore_censimento: boolean
        e_un_operatore_gestionale_report: boolean
        e_uno_di_tecnograph: boolean
    }
}

export default {
    namespaced: true,
    state: {
        userInfo: null
    } as UserState,
    getters: {
        eUnOperatoreGestionaleMapplants: (state: UserState) => state.userInfo && state.userInfo.e_un_operatore_gestionale_mapplants,
        eUnOperatoreGestionaleReport: (state: UserState) => state.userInfo && state.userInfo.e_un_operatore_gestionale_report
    },
    mutations: {
        SET_USER_INFO: (state: UserState, payload: UserState['userInfo']) => (state.userInfo = payload)
    },
    actions: {
        async fetchUserInfo({ commit, dispatch, rootGetters }) {
            if (rootGetters['auth/isAuthenticated']) {
                try {
                    const response = await Vue.axios.get('/api/utente_applicazione.json')
                    // set the user data in the states
                    const userInfo = response.data[0]
                    commit('SET_USER_INFO', userInfo)
                } catch (error) {
                    // le credenziali sono invalide probabilmente
                    dispatch('auth/logout', null, { root: true })
                    console.error(error)
                }
            }
        },
        resetEverything({ commit }) {
            // used on logout, to removed data from the state
            commit('SET_USER_INFO', null)
        }
    }
}
